export const IRREGULAR_PLURALS: Record<string, string> = {
  person: 'people',
};

const VOWELS = new Set(['a', 'e', 'i', 'o', 'u']);

export function pluralize(word: string, override?: string): string {
  if (!word) return word;
  if (override) return override;

  const lower = word.toLowerCase();

  const irregular = IRREGULAR_PLURALS[lower];
  if (irregular) {
    return word[0] === word[0].toUpperCase() && word[0] !== word[0].toLowerCase()
      ? irregular[0].toUpperCase() + irregular.slice(1)
      : irregular;
  }

  // Hyphenated compound: pluralize the last segment only (e.g. To-Do → To-Dos)
  if (word.includes('-')) {
    const parts = word.split('-');
    parts[parts.length - 1] = pluralize(parts[parts.length - 1]);
    return parts.join('-');
  }

  const len = lower.length;

  if (lower.endsWith('ch') || lower.endsWith('sh')) return word + 'es';
  if (lower.endsWith('s') || lower.endsWith('x') || lower.endsWith('z')) return word + 'es';
  if (len >= 3 && lower.endsWith('o') && !VOWELS.has(lower[len - 2])) return word + 'es';
  if (lower.endsWith('y') && len >= 2) {
    return VOWELS.has(lower[len - 2]) ? word + 's' : word.slice(0, -1) + 'ies';
  }

  return word + 's';
}
